<template>
  <h2 class="ctype__sub-indicator" v-html="content.markup"></h2>
</template>

<script>
  export default {
    name: 'SubIndicator',
    props: {
      content:{
        type: Object,
        required: true
      }
    }
  }
</script>

<style src="./SubIndicator.scss" lang="scss"></style>
